import oss from 'ali-oss';

/* eslint-disable no-template-curly-in-string */
function createCallbackBodyStr() {
  return 'bucket=${bucket}&'
    + 'object=${object}&'
    + 'size=${size}&'
    + 'mimeType=${mimeType}&'
    + 'imageInfo.height=${imageInfo.height}&'
    + 'imageInfo.width=${imageInfo.width}&'
    + 'imageInfo.format=${imageInfo.format}&'
    // Necessary to make custom vars available to backend server callback.
    + 'x:userId=${x:userId}&'
    + 'x:fileItemType=${x:fileItemType}&'
    + 'x:fileItemId=${x:fileItemId}&'
    + 'x:fileIndex=${x:fileIndex}';
}

export default {
  uploadFile(file, user, fileItemType, fileItemId, fileIndex, objKeyTemplate, httpClient) {
    // No need to upload.
    if (!file) {
      return Promise.resolve();
    }

    // Get a stsToken necessary for uploading.
    // https://help.aliyun.com/document_detail/32069.html?spm=5176.doc32072.6.739.egPhly
    const promise1 = httpClient.callServiceForObject('/aliyun/get_sts_token');
    const promise2 = httpClient.callServiceForObject('/aliyun/get_oss_info');
    return Promise.all([promise1, promise2]).then((results) => {
      const stsToken = results[0];
      const ossInfo = results[1];
      const store = oss({
        accessKeyId: stsToken.accessKeyId,
        accessKeySecret: stsToken.accessKeySecret,
        stsToken: stsToken.securityToken,
        endpoint: ossInfo.aliyunOssEndPoint,
        bucket: ossInfo.aliyunOssBucket,
        secure: true,
      });

      let objKey = objKeyTemplate
        .replace('$agencyId$', user.getLong('agencyId'))
        .replace('$pos$', (fileIndex + 1));
      // eslint-disable-next-line
      objKey += `.${file.name.slice((file.name.lastIndexOf('.') - 1 >>> 0) + 2)}`; // Extension

      // Start uploading and return a promise.
      return store.multipartUpload(objKey, file, {
        // https://github.com/ali-sdk/ali-oss#putname-file-options
        callback: {
          url: ossInfo.aliyunOssFileUploadCallbackUrl,
          body: createCallbackBodyStr(),
          contentType: 'application/x-www-form-urlencoded',
          customValue: {
            userId: `${user.getId()}`,
            fileItemType,
            fileItemId: `${fileItemId}`,
            fileIndex: `${fileIndex}`,
          },
        },
      });
    }).catch((err) => { /* No special failure handling */ });
  },
};
